import { fetcher } from '@commenda/utils';

export async function subscribeAgentFirm(
  serviceRequestId: string,
  agentFirmId: string,
  token?: string
): Promise<boolean> {
  const res = await fetcher(
    `service-request/${serviceRequestId}/subscribed-firms`,
    { method: 'POST', body: { agentFirmId } },
    token
  );

  return res.ok;
}
